import { render, staticRenderFns } from "./ContactEmailAddressLabelSelect.vue?vue&type=template&id=1a952cfd"
import script from "./ContactEmailAddressLabelSelect.vue?vue&type=script&lang=js"
export * from "./ContactEmailAddressLabelSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports